import styled from 'styled-components';

export const NotificationsPageWrapper = styled.div`
  width: 100%;
  max-width: 900px;
`;

export type StepCardProps = {
  active: boolean;
};
export const StepCard = styled.div<StepCardProps>`
  cursor: pointer;
  padding: 5px 20px;
  border-radius: 5px;
  width: fit-content;
  background-color: ${props => (props.active ? props.theme.main.color : 'transparent')};
  color: ${props => (props.active ? 'white' : 'black')};
  span {
    font-weight: bold;
    font-size: 16px;
  }
  margin-right: 5px;
`;

export const Title = styled.h3`
  display: block;
  font-size: 1.5rem;
  font-weight: 600;
  color: #393939;
`;

export const SectionTitle = styled.h3`
  display: block;
  font-size: 1.4rem;
  font-weight: 500;
  color: #393939;
`;

export const Subtitle = styled.small`
  color: #393939;
  font-size: 1rem;
  font-weight: 400;
`;

export const SelectWrapper = styled.div`
  width: 100%;
  margin: 0 0 16px;

  > div {
    width: 100%;
  }
`;

export const ReportSectionWrapper = styled.div`
  margin: 16px 0 0;
`;

export const ButtonsWrapper = styled.div`
  width: 100%;
  margin: 40px 0 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 6px;
`;

export const CheckboxesWrapper = styled.div`
  margin: 0 0 6px;

  > div {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 6px;

    .checkbox:last-of-type {
      margin-left: 22px;
    }
  }
`;

export const DateFieldsWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 6px;

  > div {
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 6px;
    width: 100%;

    &:first-of-type {
      margin-right: 16px;
    }
  }
`;

export const DateFieldPrefix = styled.span`
  display: block;
  color: #aaadb1;
  font-weight: 600;
  font-size: 1rem;
`;
